import React from 'react';
import App from './App';
import { createRoot } from 'react-dom/client';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import configureStore from './redux';
import i18n from './i18n';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { QueryProvider } from 'services/Providers/QueryProvider';
import { setServiceWorkerUpdatePending } from 'services/Utilities/serviceWorkerUpdateGuard';

export const store = configureStore();
const container = document.getElementById('root');
const root = createRoot(container);

const createUpdateAvailableEvent = registration => {
  if (typeof window.CustomEvent === 'function') {
    return new window.CustomEvent(serviceWorkerRegistration.SERVICE_WORKER_UPDATE_AVAILABLE_EVENT, {
      detail: { registration },
    });
  }

  const event = document.createEvent('CustomEvent');
  event.initCustomEvent(serviceWorkerRegistration.SERVICE_WORKER_UPDATE_AVAILABLE_EVENT, false, false, {
    registration,
  });

  return event;
};

root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <QueryProvider>
        <App />
      </QueryProvider>
    </Provider>
  </I18nextProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
const dispatchUpdateAvailable = registration => {
  setServiceWorkerUpdatePending(true);
  window.dispatchEvent(createUpdateAvailableEvent(registration));
};

serviceWorkerRegistration.register({
  onUpdate: dispatchUpdateAvailable,
});

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    if (registration.waiting) {
      dispatchUpdateAvailable(registration);
    }
  });
}
